import CurrentUserProvider from "@/providers/CurrentUserProvider"
import React from "react"
import AdminMonthlyCalendar from "./Calendar"

const AdminMonthlyCalendarPage = () => {
  return (
    <CurrentUserProvider>
      <AdminMonthlyCalendar />
    </CurrentUserProvider>
  )
}

export default AdminMonthlyCalendarPage
